import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { RepeatedAccountTemplate } from '../../templates/repeated-account.template';
import { fetchDuplicatedUserDetailsByCurpService } from '../../../services/new-services/public-v2.services';
import { LoadingFitoTemplate } from '../../templates/loading-fito.template';

export const RepeatedAccountScreen = ({ }) => {
  const { curp } = useParams();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDuplicatedUserDetailsByCurpService(curp).then(
      (x) => {
        if (x.success && x.data) {
          setPhoneNumber(x.data.primary_phone_number);
          setLoading(false);
        }
      },
    );
  }, []);

  const handlePress = () => {
    navigate('/');
  };

  if (loading) {
    return <LoadingFitoTemplate />;
  }

  return (
    <RepeatedAccountTemplate
      phoneNumber={phoneNumber}
      handlePress={handlePress}
    />
  );
}; 